import { render, staticRenderFns } from "./ComplaintFiling.vue?vue&type=template&id=bb664da0&scoped=true&"
import script from "./ComplaintFiling.vue?vue&type=script&lang=js&"
export * from "./ComplaintFiling.vue?vue&type=script&lang=js&"
import style0 from "./ComplaintFiling.vue?vue&type=style&index=0&id=bb664da0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb664da0",
  null
  
)

export default component.exports